export default __webpack_public_path__ + "static/media/logo-xl-768w.2c334474.png";